import { render, staticRenderFns } from "./signature-packet-documents.vue?vue&type=template&id=2fd671b2&scoped=true&"
import script from "./signature-packet-documents.vue?vue&type=script&lang=js&"
export * from "./signature-packet-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd671b2",
  null
  
)

export default component.exports